/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { browserName, isAndroid, isIOS } from "react-device-detect";
import {
  BottomNavigation,
  BottomNavigationAction,
  Box,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import useSWRMutation from "swr/mutation";
import { useSelector } from "react-redux";
import useSWR, { mutate } from "swr";

import EmptyNotification from "./NotificationCard/EmptyNotification";
import FollowNotification from "./NotificationCard/FollowNotification";
import HotTableNotification from "./NotificationCard/HotTableNotification";
import HotTableNotificationSummary from "./NotificationCard/HotTableNotificationSummary";
import NotificationInvitation from "./NotificationCard/NotificationInvitation";
import NotificationInvitationSummary from "./NotificationCard/NotificationInvitationSummary";
import NotificationPublish from "./NotificationCard/NotificationPublish";
import ReportAccount from "./NotificationCard/ReportAccount";
import ReportAccountEleminated from "./NotificationCard/ReportAccountEleminated";
import UseWindowDimensions from "./../../../utils/windowSize";
import { getPlayerState } from "../../../redux/features/playerSlice";
import SwipeableViews from "react-swipeable-views";
import { ModalTab } from "../ProfilePage/ProfileTabs/ModalTab/ModalTab";
import { fetcherGetToken } from "../../../services/fetcher";
import NotificationReply from "./NotificationCard/NotificationReply";
import { fetcherPost } from "../../../services/fetcher";
import EmptyState from "../EmptyState";
import NotificationLoading from "./NotificationCard/NotificationLoading";
import { GroupBy } from "../../../utils/ChunkWhile";
import AppAlertBox from "../AppAlertBox";
import { getSettingState } from "../../../redux/features/settingSlice";
import { DetectPwa } from "../../../utils/DetectPwa";

const StyleBottomNav = styled(BottomNavigationAction)(({ theme }) => ({
  "&.MuiBottomNavigationAction-root": {
    borderRadius: "7px",
    paddingTop: "3px",
    fontWeight: 400,
    fontSize: "16px",
    lineHeight: "24px",
    color: theme.palette.black.main,
    textAlign: "center",
    maxWidth: "50%",
  },
  "&.MuiBottomNavigationAction-root.Mui-selected": {
    backgroundColor: theme.palette.black.main,
    color: theme.palette.white.main,
    fontWeight: 700,
  },
}));

const NotificationPage = () => {
  const theme = useTheme();
  const [bottonTab, setButtonTab] = useState(0);
  const { height } = UseWindowDimensions();
  const { minimizePlayer } = useSelector(getPlayerState);
  const tokenStorage = JSON.parse(localStorage.getItem("token")) || null;
  const { appAlert } = useSelector(getSettingState);

  const swipeHandleChangeTab = (index) => {
    setButtonTab(index);
  };

  const handleChangeTab = (event, newValue) => {
    setButtonTab(newValue);
  };

  const { data: notification, isLoading } = useSWR(
    () => {
      return [
        `${process.env.REACT_APP_API}/notifications/?page_size=20`,
        tokenStorage,
      ];
    },
    fetcherGetToken,
    { refreshInterval: 5000 }
  );

  const { trigger } = useSWRMutation(
    [
      `${process.env.REACT_APP_API}/notifications/mark-all-as-read/`,
      tokenStorage,
    ],
    fetcherPost,
    {
      onSuccess: () => {
        mutate([
          `${process.env.REACT_APP_API}/notifications/unread-count/`,
          tokenStorage,
        ]);
      },
    }
  );

  useEffect(() => {
    async function markAsRead() {
      await trigger({ read: true });
    }
    markAsRead();
  }, [trigger]);

  const conditionNotif = (row) => {
    if (row.verb === "published a new topic") {
      return <NotificationPublish data={row} link='topic' />;
    }
    if (row.verb === "published a new opinion") {
      return <NotificationPublish data={row} link='opinion' />;
    }
    if (row.verb === "published a new conversation") {
      return <NotificationPublish data={row} link='discussion' />;
    }

    if (row.verb === "replied on your comment") {
      return <NotificationReply data={row} />;
    }

    if (row.verb === "is a hot table") {
      return <HotTableNotificationSummary data={row} />;
    }

    if (row.verb === "followed you") {
      return <FollowNotification data={row} />;
    }

    if (row.level === "warning") {
      return <ReportAccountEleminated data={row} />;
    }

    //        <ReportAccount />;
    //        <ReportAccountEleminated />
    //        <NotificationInvitation />
    //        <HotTableNotification />
    //        <NotificationInvitationSummary />
  };

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.white.main,
        height: height - 64 - (minimizePlayer ? 82 : 0) + "px",
        overflowY: "auto",
        padding: "24px 16px 0px 16px",
        overflowX: "hidden",
      }}
    >
      <Box>
        {/* Header Bottom */}
        <Box>
          <Typography
            paragraph
            sx={{
              fontWeight: "600",
              fontSize: "24px",
              marginBottom: "0px",
            }}
          >
            Notifications
          </Typography>

          {/* <Box>
            <BottomNavigation
              sx={{
                height: "48px",
                boxShadow: `0px 0px 0px 2px ${theme.palette.black.main}`,
                borderRadius: "8px",
                fontSize: "16px",
              }}
              value={bottonTab}
              onChange={handleChangeTab}
            >
              <StyleBottomNav
                value={0}
                icon={
                  <>
                    <Box
                      style={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        // backgroundColor: "#C62828",
                        position: "absolute",
                        zIndex: 100,
                        top: "10px",
                        right: "27%",
                      }}
                    ></Box>
                    <> Primary</>
                  </>
                }
              />

              <StyleBottomNav
                value={1}
                icon={
                  <>
                    <Box
                      sx={{
                        width: "8px",
                        height: "8px",
                        borderRadius: "50%",
                        backgroundColor: "danger.main",
                        position: "absolute",
                        zIndex: 100,
                        top: "10px",
                        right: "27%",
                      }}
                    ></Box>
                    <> General</>
                  </>
                }
              />
            </BottomNavigation>
          </Box> */}
        </Box>
        {/* End Header Bottom */}

        {/* <SwipeableViews
          style={{
            width: "100%",
            height: "100%",
            marginTop: "4px",
          }}
          index={bottonTab}
          onChangeIndex={swipeHandleChangeTab}
        >
          <ModalTab value={bottonTab} index={0}> */}
        {(isLoading || !notification) &&
          Array(12)
            .fill("")
            .map((e, i) => {
              return <NotificationLoading key={i} />;
            })}
        {notification?.results.length === 0 && <EmptyNotification />}

        {notification &&
          Object.entries(
            GroupBy(notification.results, function (i) {
              return (
                new Date(i.timestamp).getTime() <
                new Date().getTime() - 86400000
              );
            })
          ).map((row, i) => {
            return (
              <Box key={i}>
                {!isLoading && notification?.results.length !== 0 && (
                  <Box
                    style={{
                      display: "flex",
                      alignItems: "center",
                      fontWeight: "600",
                      size: "400",
                      paddingTop: "8px",
                      marginBottom: "8px",
                    }}
                  >
                    <Box
                      style={{
                        width: "15%",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      {!JSON.parse(row[0]) ? "Today" : "Earlier"}
                    </Box>
                    <Box
                      style={{
                        width: "84%",
                        height: "2px",
                        backgroundColor: JSON.parse(row[0]) ? "black" : "none",
                      }}
                    ></Box>
                  </Box>
                )}
                {/* {(isIOS || isAndroid) &&
                appAlert &&
                DetectPwa() !== "pwa" &&
                browserName !== "Chrome WebView" && <AppAlertBox icon />} */}

                {row[1].map((notifRow) => {
                  return (
                    <Box key={notifRow.pk}>{conditionNotif(notifRow)}</Box>
                  );
                })}
              </Box>
            );
          })}
        {/* </ModalTab> */}

        {/* <ModalTab value={bottonTab} index={1}>
            22222222222222222222222222 22222222222222222222222
          </ModalTab>
        </SwipeableViews> */}
      </Box>
    </Box>
  );
};

export default NotificationPage;
